import React from 'react'
import {Helmet} from 'react-helmet'
import {usePageContext} from 'Src/components/pages/SoftPull/PageContext'

const Header = () => {
  const {pageHeading} = usePageContext()

  return (
    <>
      <Helmet>
        <title>{pageHeading}</title>
      </Helmet>
      <h2 className="h3 tw-mx-6 tw-mb-4 tw-text-left">{pageHeading}</h2>
    </>
  )
}

export default Header
